(function() {
  'use strict';
  
  angular
    .module('plugins.word-cloud')
    .controller('WordCloudResultHiddenController', WordCloudResultHiddenController);
  
  WordCloudResultHiddenController.$inject = [
    '$log', 
    '$scope',
    'pollPluginService'
  ];
    
  function WordCloudResultHiddenController(
      $log, 
      $scope,
      pollPluginService
    ) {
    $log = $log.getInstance('WordCloudResultHiddenController');
    
    /* jshint validthis: true */
    var vm = this;
    
    activate();
    
    function activate() {
      pollPluginService.onResponseReceived($scope, $scope.result._id, _onResponseReceived);
    }
    
    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
    }

  }
  
})();